import about from './zh/about'
import product from './zh/product'
import matpl from './zh/p_matpl'
import pwmodule from './zh/p_module'
import pwkit from './zh/p_pwkit'
import qflow from './zh/p_qflow'
import qstudio from './zh/p_qstudio'
import allinone from './zh/p_allinone'
import gpu from './zh/download/pwmat'
import ls3df from './zh/download/ls3df'
import potential from './zh/download/potential'
import utility from './zh/download/utility'
import more from './zh/more'

export default{
  ...about,
  ...product,
  ...matpl,
  ...pwmodule,
  ...pwkit,
  ...qflow,
  ...qstudio,
  ...allinone,
  ...gpu,
  ...ls3df,
  ...potential,
  ...utility,
  ...more,
  language: {
    name: 'EN'
  },
  navbar: {
    Home:'首页',
    About:'关于我们',
    CompanyProfile:'公司简介',
    CompanyNews:'公司动态',
    AcademicDemo: '学术教育方案',
    IndustryDemo: '工业行业方案',
    Customers: '合作客户',
    ContactUs:'联系我们',
    JoinUs:'加入我们',
    product:'产品介绍',
    Trial: '限时试用',
    Solution:'软硬一体化',
    Features: '专项功能模块',
    Forum:'论坛',
    Video:'视频教程',
    Download:'下载',
    SoftWareDownload:'PWmat',
    PWmatGPU:'GPU 版本',
    PWmatDCU:'DCU 版本',
    PWmatCPU:'CPU 版本',
    PWmatWin:'Windows 版本',
    PWmatTry:'免费试用 License',
    PotentialDownload:'赝势文件',
    PWmatManual:'PWmat 手册',
    PWmatzhVer:'中文版',
    PWmatenVer:'英文版',
    QflowManual:'Q-Flow 手册',
    QstudioManual:'Q-Studio 手册',
    Course:'资源中心',
    Tutorial:'使用指南',
    CommonParameter:'常用参数详解',
    TypicalLiterature:'典型文献复现',
    PublishedPapers:'发表论文解读',
    ModuleClassroom:'module 小课堂',
    GettingStartedVideo:'入门教程视频',
    SpecialVideo:'专题课程视频',
    SpecialVideo2:'训练营专题课程视频',
    SpecialVideo3:'Q-Studio 建模小技巧',
    BigVideo:'大咖讲坛视频',
    BigVideo2:'大咖讲坛',
    BigVideo3:'龙讯讲坛',
    BigVideo4:'龙讯研讨班',
    BigVideo5:'会议报告',
    More:'更多',
    Log:'更新日志',
    BugLog: 'Bug 日志',
    Paper:'论文',

  },
  footer:{
    QuickLink:'快速链接',
    FriendlyLink:'友情链接',
    Company:'北京龙讯旷腾科技有限公司',
    JoinUs:'招贤纳士',
    Tutorials:'教程',
    Trial:'试用版',
    forum: '龙讯讲坛',
    link01: '北大新材料',
    phone1: '销售电话：',
    phone2: '市场电话：',
    wechat: '公众号',
  },
  carousel:{
    title: '人工智能驱动新材料研发',
    subtitle: 'AI 赋能材料研发与计算领军企业',
    title1:'材料智能研发平台 IntelliMat',
    subtitle1:'知识库、工具执行、专业技能、工作流编排',
    button1:'了解更多',
    title2:'Q-studio AI ',
    subtitle2:'融合大语言模型和交互能力的AI材料计算智能体',
    title3:'机器学习力场软件 MatPL',
    subtitle3:'实现全球范围内首例DFT精度万亿原子分子动力学模拟',
    title4:'原子尺度材料智能计算一体机 QStation',
    subtitle4:'精准建模、智慧组合、智能优化、洞悉物性、图谱呈现',
    title5:'第一性原理计算软件 PWmat',
    subtitle5:'特色功能: Fast HSE、Electron-Phonon Coupling、rt-TDDFT、NAMD、Solvent Model、Charge Patching Method',
    title6:'免费DFT计算半年包PWstudio',
    subtitle6:'全功能版PWmat、可视化工作流Q-Flow、在线建模Q-Studio集成安装包',
  },
  home: {
    productlist: '明星产品',
    allinone: '一体机',
    about: '超算云',
    mcloud: `Mcloud 是由龙讯旷腾搭建的高性能集群和云桌面组成的超算云平台，云平台集成了 PWmat、Q-Flow、Q-Studio以及 Lammps 等软件，提供 SaaS 材料模拟计算服务，用户可以自主完成注册，注册之后即可在线使用 PWmat 等软件和丰富 GPU 卡时资源。`,
    register: '注册',
    PWstudio: '限时6个月试用安装包 PWstudio',
    PWstudioIntroductor: `PWstudio 是一款集合了 PWmat、Q-Flow 可视化工作流工具、Q-Studio 建模工具的一键式安装软件包，从注册日起限时6个月试用。其中 PWmat license 包含了已适配优化的 CPU 及 GPU 版本 License，用户须自备 CPU 或 GPU 服务器，自主完成环境搭建、服务安装部署及校验，6个月期满后 License 将自动失效。`,
    IntelliMat: '材料智能研发平台 IntelliMat',
    IntelliMatIntroductor: "IntelliMat 是一款面向材料研发全流程的智能工作平台，除了包含交互式AI问答功能以外，在知识库、工具执行、专业技能与工作流编排四个核心层面进行系统性构建。其中，Superflow 工作流编排模块是其他同领域 Agent 平台不具备的优势功能，可以将 Agent 的一次性执行转化为可保存、可复现、可调度、可发布的标准化研发流程，解决材料研发中因环境差异、版本变更和人工操作导致的任务不可复现问题，消除 AI 多次执行结果不一致的风险，让关键步骤、参数与计算资源被明确固定。",
    click: '了解更多',
    news: '公司动态',
    honor: '荣誉奖项',
    ecological: '生态建设',
    Strategic: '战略合作',
    cooperate: '合作伙伴',
  }
}
